import { render, staticRenderFns } from "./TheSideNavigationBar.vue?vue&type=template&id=a37182ea&"
import script from "./TheSideNavigationBar.vue?vue&type=script&lang=js&"
export * from "./TheSideNavigationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports